module.exports = __webpack_public_path__ + "resources/img/bg_cover_solution.3b5d550cebbfab69ae3e4d1a5228a66c.png";